/* Ember cart lanterns — v1.0
   Diwali add-to-cart animation. When an item is added, festive lanterns rise from
   the clicked add-to-cart button and drift to that product's image (collection
   card, "mostly paired with", or the main PDP gallery), fading as they arrive.

   Same add-to-cart detection surface as ember-cart-confetti.js (fetch / XHR /
   form submit / theme pub-sub). Lantern artwork + tuning are merchant-set in
   Online Store > Customize > Cart Lanterns (Diwali); window.__emberLanternSettings
   carries the resolved image URLs and knobs. No dependencies. */

(function () {
  'use strict';
  if (window.__emberLanterns) return;
  window.__emberLanterns = true;

  var S = window.__emberLanternSettings || {};
  var CONFIG = {
    images: (S.images || []).filter(Boolean),
    count: typeof S.count === 'number' && S.count > 0 ? S.count : 8,
    scale: typeof S.size === 'number' && S.size > 0 ? S.size : 1,     // multiplier
    duration: typeof S.duration === 'number' && S.duration > 0 ? S.duration : 1200,
    base: 46,            // base sprite height in px (before scale)
    zIndex: 2147483000,
    cooldown: 1200   // one burst per add; swallows the fetch+submit pair + the animation window
  };
  if (!CONFIG.images.length) return; // no art configured -> do nothing (fail-closed)

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- preload art ---------- */
  var sprites = [];
  CONFIG.images.forEach(function (url) {
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
    sprites.push(img);
  });

  /* ---------- canvas ---------- */
  var canvas, ctx, dpr = 1, raf = null, flyers = [], safetyTimer = null;
  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;' +
      'pointer-events:none;z-index:' + CONFIG.zIndex + ';';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize, { passive: true });
  }
  function resize() {
    if (!canvas) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  /* ---------- geometry helpers ---------- */
  function rand(a, b) { return a + Math.random() * (b - a); }
  function centerOf(rect) { return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 }; }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  // The add-to-cart button most recently pressed (origin + how we find the image),
  // plus a one-shot "the user just clicked add" gesture. The animation fires ONLY for
  // a fresh user click — programmatic /cart/add calls (auto-added free gifts, spend-gift
  // / BXGY adders that fire a few seconds after an add) carry no gesture and are skipped.
  var lastBtn = null, lastPointer = null, pendingGesture = false, lastGestureTime = 0;
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    var btn = t.closest && t.closest(
      'button[type="submit"], [data-cpv2-btn], [data-add-to-cart], .cpv2__add-btn, ' +
      '.product-form__submit, .add-to-cart, [name="add"]'
    );
    lastPointer = { x: e.clientX, y: e.clientY };
    if (btn) { lastBtn = btn; pendingGesture = true; lastGestureTime = Date.now(); }
  }, { passive: true, capture: true });

  // First visible image (by selector priority) inside a scope element.
  function imgIn(scope, sels) {
    for (var i = 0; i < sels.length; i++) {
      var im = scope.querySelector(sels[i]);
      if (im) { var r = im.getBoundingClientRect(); if (r.width > 6 && r.height > 6) return r; }
    }
    return null;
  }
  // Resolve the product image this add-to-cart belongs to. Specific container
  // first (collection card / paired-with slide / cart line), then the PDP gallery.
  function targetRect(btn) {
    if (btn && btn.closest) {
      var card = btn.closest('[data-product-card], .cpv2');
      if (card) { var rc = imgIn(card, ['[data-cpv2-image-wrap] img', '.cpv2__image', 'img']); if (rc) return rc; }
      // "Mostly paired with" (and any swiper card): image lives in .image img.
      var slide = btn.closest('.paired_products .swiper-slide, .swiper-slide');
      if (slide) { var rs = imgIn(slide, ['.image img', '.cpv2__image', 'img']); if (rs) return rs; }
      var line = btn.closest('.cart-item, [data-cart-item], cart-item');
      if (line) { var rl = imgIn(line, ['img']); if (rl) return rl; }
    }
    // Main PDP gallery — largest visible product image on screen.
    var pdp = document.querySelectorAll(
      '.product__media-wrapper img, .product-media-gallary-new img, .product__media img, .product-media img, [data-product-image] img, [data-product-image]'
    );
    var best = null, area = 0;
    for (var j = 0; j < pdp.length; j++) {
      var rr = pdp[j].getBoundingClientRect();
      if (rr.width > 6 && rr.height > 6 && rr.bottom > 0 && rr.top < window.innerHeight && rr.width * rr.height > area) {
        area = rr.width * rr.height; best = rr;
      }
    }
    return best;
  }

  /* ---------- launch ---------- */
  var lastFire = 0;
  function launch() {
    if (reduceMotion || document.hidden) return;
    // Only celebrate a fresh USER add-click. No gesture (or a stale one) => this /cart/add
    // was programmatic (auto-added gift, spend-gift adder) => skip. Consume so one click = one burst.
    if (!pendingGesture || Date.now() - lastGestureTime > 4000) { pendingGesture = false; return; }
    pendingGesture = false;
    var now = Date.now();
    if (now - lastFire < CONFIG.cooldown) return;
    lastFire = now;

    // Emerge from the TOP-CENTER of the add-to-cart button and shoot up as a wide sparkle burst.
    var obr = lastBtn ? lastBtn.getBoundingClientRect() : null;
    var origin = obr ? { x: obr.left + obr.width / 2, y: obr.top }
      : (lastPointer || { x: window.innerWidth / 2, y: window.innerHeight * 0.7 });
    // Rise reference: the product image's bottom edge; stars scatter to varying heights around it.
    var tgt = targetRect(lastBtn);
    var endY = tgt ? tgt.bottom : origin.y - 240;
    if (endY > origin.y - 40) endY = origin.y - 240; // always rise a sensible amount

    ensureCanvas();
    var ready = sprites.filter(function (s) { return s.complete && s.naturalWidth; });
    if (!ready.length) ready = sprites; // draw once decoded

    var stagger = Math.min(70, CONFIG.duration * 0.045);
    var riseRef = Math.max(130, origin.y - endY); // button -> image distance, used as the rise reference
    // Stars fan out WIDE (well beyond the button) per the MP4 — a sparkle burst, not a contained column.
    var spreadW = tgt ? Math.max(110, tgt.width * 0.5) : 150;
    for (var i = 0; i < CONFIG.count; i++) {
      var img = ready[i % ready.length];
      // Shoot up into a wide, varying-height cloud; varying star sizes; slow spin; twinkle.
      flyers.push({
        img: img,
        x0: origin.x + rand(-12, 12), y0: origin.y + rand(-4, 6),
        x1: origin.x + rand(-spreadW, spreadW),               // wide horizontal scatter
        y1: origin.y - riseRef * rand(0.45, 1.15),            // varying rise heights (a cloud, not one line)
        h: CONFIG.base * CONFIG.scale * rand(0.45, 1.35),     // varying star sizes
        rot0: rand(0, 6.28), rotSpeed: (rand(0, 1) < 0.5 ? -1 : 1) * rand(0.004, 0.0075), // vertical-axis spin (slower, ~1-1.7 turns while rising)
        twPhase: rand(0, 6.28), twFreq: rand(0.45, 1.05),     // twinkle shimmer
        delay: i * stagger + rand(0, 140), dur: CONFIG.duration * rand(0.65, 1.1),
        start: 0
      });
    }
    if (!raf) raf = requestAnimationFrame(step);
    // Safety net: force-clear after the whole burst's max lifetime, so a dropped/paused rAF frame
    // (backgrounded tab / mobile webview) or any draw exception can NEVER leave stars frozen on
    // screen — this is the fix for the intermittent "animation gets stuck" report.
    var maxLife = CONFIG.duration * 1.2 + CONFIG.count * stagger + 900;
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(hardStop, maxLife);
  }

  // Cancel the loop, drop all sprites, wipe the canvas. Idempotent; safe to call anytime.
  function hardStop() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    flyers.length = 0;
    if (ctx && canvas) { try { ctx.clearRect(0, 0, canvas.width, canvas.height); } catch (e) {} }
  }

  function step(ts) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var alive = 0;
    for (var i = 0; i < flyers.length; i++) {
      var f = flyers[i];
      if (!f.start) f.start = ts;
      var elapsed = ts - f.start - f.delay;
      if (elapsed < 0) { alive++; continue; }
      var t = elapsed / f.dur;
      if (t >= 1) continue;
      alive++;
      // easeOut rise — quick shoot-up out of the button, decelerating as it travels.
      var e = 1 - Math.pow(1 - t, 2);
      var x = f.x0 + (f.x1 - f.x0) * e;
      var y = f.y0 + (f.y1 - f.y0) * e;
      // Envelope: fade in fast, fade out over the back half as the star rises and dims away.
      var env = t < 0.1 ? t / 0.1 : (t > 0.5 ? Math.max(0, (1 - t) / 0.5) : 1);
      var img = f.img;
      // Skip any sprite that isn't a fully-decoded image with real dimensions. naturalHeight
      // MUST be checked too — a 0 height makes `w` non-finite below, and drawImage then THROWS,
      // which (without the try/catch) would kill the rAF loop mid-frame and freeze the stars.
      if (!img.complete || !img.naturalWidth || !img.naturalHeight) continue;
      // Vertical-axis spin — compute the angle first so the shading can track it.
      var spin = f.rot0 + ts * f.rotSpeed;
      var cosS = Math.cos(spin), sinS = Math.sin(spin);
      // Make a flat star read as a 3D turn: (1) DIM edge-on / bright face-on, (2) the back face
      // (cos<0) a touch dimmer than the front, (3) a gentle twinkle on top.
      var tw = Math.sin(ts * 0.013 * f.twFreq + f.twPhase); // -1..1
      var face = 0.3 + 0.7 * Math.abs(cosS);                // edge-on = dim, face-on = bright
      var faceDepth = cosS >= 0 ? 1 : 0.78;                 // back side slightly dimmer -> front/back 3D read
      var op = env * face * faceDepth * (0.85 + 0.15 * tw);
      var sc = 1 + 0.12 * tw;                               // gentle sparkle size pulse
      var h = f.h * sc, w = h * (img.naturalWidth / img.naturalHeight);
      if (!isFinite(w) || !isFinite(h) || w <= 0 || h <= 0) continue; // never hand bad dims to drawImage
      // A single bad sprite/draw must NEVER kill the loop — that leaves the last frame frozen.
      try {
        ctx.save();
        ctx.globalAlpha = Math.max(0, op);
        ctx.translate(x, y);
        // Pseudo-3D vertical-axis spin: width squishes by cos(angle) AND a sin-driven horizontal
        // shear leans the star, so it tumbles in depth instead of just flattening.
        ctx.transform(cosS, 0, sinS * 0.22, 1, 0, 0);
        ctx.drawImage(img, -w / 2, -h / 2, w, h);
        ctx.restore();
      } catch (e) {
        try { ctx.restore(); } catch (e2) {}
      }
    }
    // prune finished flyers occasionally
    if (alive === 0) { clearTimeout(safetyTimer); flyers.length = 0; raf = null; ctx.clearRect(0, 0, canvas.width, canvas.height); return; }
    raf = requestAnimationFrame(step);
  }

  // If the page is hidden mid-burst, rAF pauses and the last frame can sit frozen. Clear it now
  // so nothing is stuck when the user returns (and the next add-to-cart starts clean).
  document.addEventListener('visibilitychange', function () { if (document.hidden) hardStop(); });

  /* ---------- add-to-cart detection (mirrors ember-cart-confetti.js) ---------- */
  function isAddUrl(url) {
    try {
      var u = new URL(String(url), location.href);
      return u.origin === location.origin && /\/cart\/add(\.js)?$/.test(u.pathname);
    } catch (e) { return false; }
  }
  // 1. fetch
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = (input && input.url) || input;
      var p = nativeFetch.apply(this, arguments);
      if (isAddUrl(url)) p.then(function (res) { if (res && res.ok) launch(); }).catch(function () {});
      return p;
    };
  }
  // 2. XHR
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__lanternAdd = isAddUrl(url);
    return open.apply(this, arguments);
  };
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__lanternAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) launch();
      });
    }
    return send.apply(this, arguments);
  };
  // 3. product form submit (themes that post the form directly)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) {
      setTimeout(launch, 260);
    }
  }, true);
  // Deliberately NO broad pub/sub net (cartUpdate / cart-drawer:open / cart:refresh):
  // those fire on every cart change AND on merely opening the drawer, which re-triggered
  // the animation several times per add and on non-add actions. The /cart/add request
  // above is the single authoritative "item added" signal; the cooldown de-dupes the
  // fetch+submit pair that one add can produce.
})();
